import React, { useEffect } from 'react'
import ListPosts from '../Utils/ListPosts'
import { useDispatch, useSelector } from 'react-redux'
import { getActiveToken, getToken } from '../../RTK/Slice/Auth/AuthSlice'
import { getHasNextSearch, getNextPostsAPI, getPagePostsSearch, getPagePostsSearchAPI } from '../../RTK/Slice/Extract/ExtractPageSearchSlice'
import { useParams } from 'react-router-dom'

const GetPostsOfPageSearch = () => {


    // For Get Token
    const token = useSelector(getToken) ;

    // For Get Active Token
    const activeToken = useSelector(getActiveToken) ; 

    // For Disaptch Action
    const dispatch = useDispatch();

    // For Access Params 
    const {pageID} = useParams() ; 

    // For Get Post Of Page 
    useEffect(()=>{
        dispatch(getPagePostsSearchAPI({token , userToken : activeToken ,pageId :pageID }))
    } , [])

    // For Access Data (posts ,statusOfPosts)
    const {posts  , statusOfPosts} = useSelector(getPagePostsSearch ); 

    // For Access Get Next Post
    const hasNext = useSelector(getHasNextSearch) ;

    // For Get The Has Next Handler 
    const getTheNextHandler = ()=>{
      dispatch(getNextPostsAPI({token , hasNext , userToken : activeToken , pageId : pageID}))
    }

  return (
    <div>
        <ListPosts hasNext={hasNext} hasNextHandler={getTheNextHandler} posts={posts} status={statusOfPosts} />
    </div>
  )
}

export default GetPostsOfPageSearch
